import type { ReactNode } from 'react';

import { FieldError } from '@nesso/ui/primitives/field';
import { RadioGroup } from '@nesso/ui/primitives/radio-group';
import { RadioGroupItemField } from '@nesso/ui/primitives/radio-group-item-field';

import { paymentMethodOptions } from '@/entities/payment';

import type { RecordPaymentFormValues } from '../../../../model/record-payment-form.schema';

type Method = NonNullable<RecordPaymentFormValues['method']>;

type Props = {
    value: Method | undefined;
    error?: string;
    disabled?: boolean;
    onValueChange: (method: Method) => void;
    children: ReactNode;
};

export function RecordPaymentSheetMethod({
    value,
    error,
    disabled,
    onValueChange,
    children,
}: Props) {
    return (
        <section className="flex flex-col gap-4">
            <h3 className="text-lg font-bold">Select payment method</h3>
            <RadioGroup<Method>
                aria-label="Select payment method"
                value={value ?? null}
                onValueChange={onValueChange}
            >
                {paymentMethodOptions.map((option) => (
                    <div key={option.value}>
                        <RadioGroupItemField
                            id={`record-payment-method-${option.value.toLowerCase()}`}
                            value={option.value}
                            label={option.label}
                            description={option.description}
                            disabled={disabled || option.disabled}
                        />
                        {value === option.value && <div className="px-6 pt-2 pb-6">{children}</div>}
                    </div>
                ))}
            </RadioGroup>
            {error && <FieldError>{error}</FieldError>}
        </section>
    );
}
